// Base container for the app.
// data Pulled from Azure, sorted as required and passed to each component
// Component are then built into the app if there is data associated.
import React, { useContext, useState } from "react";
import { Context } from "../Store";
import { useParams, useLocation } from "react-router-dom";
import Header from "../components/Header";
import Players from "../components/Players";
import ActionReplays from "../components/ActionReplays";
import GroupPhotos from "../components/GroupPhotos";
import Games from "../components/Games";
import LoadingStory from "../components/LoadingStory";
import { getVenueName } from "../utils/venues";
import getStoryData from "../utils/storyData";
import { getStoriesAzureAPI } from "../utils/getStoriesAzureApi";
import { openLightbox, handleHover } from "../utils/storyUIHandlers";
import Leaderboard from "../components/Leaderboard";
import HeaderIntroText from "../components/HeaderIntroText";
import NextVisit from "../components/NextVisit";
import Share from "../components/Share";
import CopiedContext from "../CopiedContext";
import IsCopiedMessage from "../components/IsCopiedMessage";
import GameCommentary from "../components/GameCommentary";
import Form from "../components/Form";
import StoryDeleted from "../components/StoryDeleted";
import Review from "../components/Review";

const StoryContainer = () => {
  // Setting app context to Store.js Where the overall state is kept
  const [state, setState] = useContext(Context);
  const [showCopied, setShowCopied] = useState(false);
  const copied = { showCopied, setShowCopied };
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const debug = params.get("debug");
  const forceCountry = params.get("country");
  const { StoriesAzureAPI, country } = getStoriesAzureAPI(forceCountry);

  // On load will use the string after the first slash (/) as the GUID
  // to request Stories data from the Azure API. Will work both with or without the trailing #/ in the URL
  let { guid } = useParams();

  // Check if state has been set. If not get data from guid and set display to "Loading"
  // Story has been deleted (API returned 204)
  if (state.deleted) {
    return <StoryDeleted />;
  }

  if (state.guid.length < 1) {
    getStoryData({
      id: guid,
      country,
      StoriesAzureAPI,
      debug,
      getVenueName,
      setState,
      state,
    });
    return (
      <div>
        <LoadingStory />
      </div>
    );
  }

  return (
    <CopiedContext.Provider value={copied}>
      <div>
        <Header />
        {state.country !== "uk" && <HeaderIntroText />}
        {state.country === "uk" && <GameCommentary />}
        <Players />
        {state.actionReplays.length >= 1 && (
          <ActionReplays
            handleHover={handleHover}
            openLightbox={openLightbox}
          />
        )}
        {(state.feedbackurl || state.googleurl) && <Review />}
        <Share />
        {(state.photos.length >= 1 || state.loopcams.length >= 1) && (
          <GroupPhotos handleHover={handleHover} openLightbox={openLightbox} />
        )}
        {state.games.length >= 1 && (
          <Games handleHover={handleHover} openLightbox={openLightbox} />
        )}
        <Leaderboard />
        {(state.country === "uk" ||
          state.venue.toLowerCase() === "atlanta" ||
          state.venue.toLowerCase() === "las vegas" ||
          state.venue.toLowerCase() === "st louis") && <Form />}
        <NextVisit />
        <IsCopiedMessage />
      </div>
    </CopiedContext.Provider>
  );
};

export default StoryContainer;
